<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'" v-bg="{image: plain.image, alternative: true, dir: 'to left'}">

    <app-loader v-if="loading"></app-loader>
    <div v-else id="plain">
      <div class="back-browser fadein-browser"
      @click="finish" v-if="$store.getters.platform === 'browser'">
        <icon name="arrow-left"></icon>
      </div>
      <div>
        <h6>{{plain.title | truncateText(100)}}</h6>
        <p><pre>{{plain.text | truncateText(600)}}</pre></p>
        <!-- <div class="finish" @click="finish">Continuar <icon name="arrow-right"></icon></div> -->
      </div>
    </div>

  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import {StatsPlain} from '@/utils/constants'
const contentsService = require('@/services/contents.js')

export default {
  name: 'Plain',
  props: ['id'],
  components: { 'app-loader': Loader },
  data () {
    return {
      plain: {}
    }
  },
  created: function () {
    contentsService.getPlain(this.id).then(response => {
      this.plain = response.data
      window.Countly.q.push(['track_pageview', StatsPlain + ' ' + this.plain.id + ': ' + this.plain.name])
    })

    if (this.$store.getters.platform === 'browser') {
      const backRoot = document.getElementById('back-browser-root')
      if (backRoot) backRoot.style.display = 'none'
    }
  },
  mounted: function () {
    // control keys
    Bus.$on('key-enter', this.finish)
    Bus.$on('key-back', this.finish)
  },
  computed: {
    loading: function () { return Object.keys(this.plain).length === 0 }
  },
  methods: {
    finish: function () {
      this.$emit('onFinish')
    }
  },
  beforeDestroy: function () {
    if (this.$store.getters.platform === 'browser') {
      const backRoot = document.getElementById('back-browser-root')
      if (backRoot) backRoot.style.display = 'block'
    }
    Bus.$off('key-enter', this.finish)
    Bus.$off('key-back', this.finish)
  }
}
</script>

<style lang="sass" scoped>
#plain
  position: relative
  width: 100vw
  height: 100vh
  padding: 3rem
  color: white

  display: flex
  display: -webkit-flex
  flex-direction: row
  justify-content: flex-end
  align-items: center

  div:not(#back-browser-plain)
    width: 60vw

    h6
      font-size: 2rem

    p
      font-size: 1.8rem
      line-height: 1.1

      pre
        white-space: pre-wrap
        font-family: "Roboto"

    .finish
      cursor: pointer
      width: 100%
      text-align: right
      font-size: 2rem
      font-weight: bold

@media screen and (max-width: 700px)
  h6
    font-size: 1rem!important
  p, pre
    font-size: 1rem

</style>



// WEBPACK FOOTER //
// src/components/Plain.vue